import React, { Component, useEffect, useState } from "react";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { PostApi } from "../../../js_assets/Network";
import axios from "axios";
import { api_url } from "../../../js_assets/ConfigApp";
import { GetApi } from "../../../js_assets/Network";
import CircularProgress from "@material-ui/core/CircularProgress";
import List from "@material-ui/core/List";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import { useForm, Controller } from "react-hook-form";
function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = (theme) => ({
    divider: {
        width: "100%",
    },
    ButtonGuide: {
        backgroundColor: "#74cbc4",
        color: "white",
        "&:hover": {
            background: "#74cbc4",
        },
        margin: theme.spacing.unit,
        padding: "5px",
        borderRadius: "5px",
        fontSize: 15,
        boxShadow: " 0 4px 8px 0 rgba(0,0,0,0.2);",
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
    iocns: {
        fontSize: 18,
    },
    canceliocn: {
        color: "black",
        float: "left",
    },
    p_followUp_Schedule_Description: {
        maxWidth: 270,
        lineHeight: "2.7em",
    },
    ButtonSubscription: {
        backgroundColor: "#74cbc4",
        color: "white",
        "&:hover": {
            background: "#74cbc4",
        },
        fontSize: 15,
        boxShadow: " 0 4px 8px 0 rgba(0,0,0,0.2);",
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
    btn_login: {
        color: "white",
        padding: "10px 1px",
        border: "none",
        cursor: "pointer",
        width: "100%",
        opacity: "0.9",
        borderRadius: "3px",
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
    tab: {
        flexGrow: 1,
        marginTop: -5,
        backgroundColor: "#f7faea",
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
    tab_button: {
        fontSize: 18,
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
});

function SubscriptionOffer(props) {

    const [loading_state_iocn, setLoading_state_iocn] = useState(true);
    const [openDialogContent, setOpenDialogContent] = useState(true);
    const { classes } = props;
    const Admin_Info = JSON.parse(localStorage.getItem("Admin_Info"))
    const { reset, setValue, handleSubmit, errors, register, watch } = useForm({});

    const values = watch();


    useEffect(() => {
        setValue("trainer_Id", props.TrainerID);
        setValue("subscription_Duration", "");
        setValue("subscription_Offer_Duration", "")
        setOpenDialogContent(true)
        handleopen_DialogContent_trainer_Rating(props.TrainerID)

    }, [props.TrainerID]);

    useEffect(() => {
        register("trainer_Id", { required: true });
        register("subscription_Duration", { required: true });
        register("subscription_Offer_Duration", { required: true });
    }, []);


    const handleopen_DialogContent_trainer_Rating = (TrainerID) => {
        setLoading_state_iocn(true)

        axios.get(`${api_url}/api/Admin/Get_Subscription_Offer/${TrainerID}`)
            .then((result) => {


                if (result.data.length != 0) {
                    setValue("subscription_Duration", result.data[0].subscription_Duration);
                    setValue("subscription_Offer_Duration", result.data[0].subscription_Offer_Duration)
                }

                setLoading_state_iocn(false)

            })
            .catch(function (error) {
                //console.log(error);
            });
    };

    const Delete_Rating = (ID) => {

        GetApi(
            `/api/Admin/Delete_Subscription_Offer/${ID}`,
            Admin_Info.jwT_Token_Admin
        ).then(() => {
            setValue("subscription_Duration", "");
            setValue("subscription_Offer_Duration", "")
            alert("تم الحدف");
        });
    };

    function Save_Offerr() {
        setLoading_state_iocn(true)
        PostApi(
            `/api/admin/Save_Subscription_Offers`,
            {
                trainer_Id: parseInt(values.trainer_Id),
                subscription_Duration: parseInt(values.subscription_Duration),
                subscription_Offer_Duration: parseInt(values.subscription_Offer_Duration),
            },
            Admin_Info.jwT_Token_Admin
        ).then(() => {
            setLoading_state_iocn(false)
            
            alert("تم الحفظ")
        });
    }

    const handleClose_DialogContent_trainer_Active = () => {
        setLoading_state_iocn(false)
        setOpenDialogContent(false)
        props.handle_Close_DialogContent_SubscriptionOffer()
    };

    if (loading_state_iocn) {
        return (
            <Dialog
                fullWidth={"sm"}
                maxWidth={"sm"}
                open
                onClose={handleClose_DialogContent_trainer_Active}
                aria-labelledby="max-width-dialog-title"
            >
                <CircularProgress />
            </Dialog>

        )

    } else {
        return (
            <Dialog
                fullWidth={"sm"}
                maxWidth={"sm"}
                open={openDialogContent}
                onClose={handleClose_DialogContent_trainer_Active}
                aria-labelledby="max-width-dialog-title"
            >
                <DialogContent >
                    <span> رقم المدرب </span>
                    <span>{values.trainer_Id}</span>
                    <div style={{ padding: 10 }}>

                        <span> مدة الاشتراك</span>
                        <div >
                            <input

                                placeholder="مدة الاشتراك"
                                name="subscription_Duration"
                                value={values.subscription_Duration}
                                onChange={e => setValue("subscription_Duration", e.target.value)}
                            />
                        </div>

                        <span>عدد الايام المجانية</span>
                        <div >
                            <input

                                placeholder=" عدد الايام المجانية"
                                name="subscription_Offer_Duration"
                                value={values.subscription_Offer_Duration}
                                onChange={e => setValue("subscription_Offer_Duration", e.target.value)}
                            />
                        </div>



                    </div>

                    <Grid
                        justify="center"
                        alignItems="center"
                        container
                        spacing={8}
                        style={{ padding: 10 }}
                    >

                        <Grid item xs>
                            <button

                                className={classes.ButtonSubscription}
                                onClick={() => { handleSubmit(Save_Offerr()) }}
                            >
                                حفظ
                            </button>
                        </Grid>
                        <Grid item xs>
                            <button
                                style={{ backgroundColor: "red" }}
                                className={classes.ButtonSubscription}
                                onClick={() => {
                                    if (
                                        window.confirm(
                                            "هل متاكد انك تبغى تحدف  ؟؟"
                                        )
                                    )
                                        Delete_Rating(values.trainer_Id);
                                }}
                            >
                                حذف
                            </button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>

        );

    }


}

SubscriptionOffer.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SubscriptionOffer);
